import styled from 'styled-components';

import { CardItem } from 'src/app/components/Elements/Card';
import { Typography } from 'src/app/components/Elements/Typography';

export const ExpressScriptsNote = styled(Typography)`
  display: block;
  color: ${props => props.theme.colors.capsuleBlue50} !important;

  font-style: normal !important;
  font-family: ${props => props.theme.fonts.circular} !important;
  font-weight: ${props => props.theme.fontWeights.semiBold} !important;
  font-size: ${props => props.theme.fontSizes.small} !important;
  line-height: ${props => props.theme.space['1.25']} !important;

  padding-top: ${props => props.theme.space['1.0']} !important;
  padding-bottom: ${props => props.theme.space['2.0']} !important;
  padding-left: ${props => props.theme.space['2.0']} !important;
  padding-right: ${props => props.theme.space['2.0']} !important;
`;

export const CardItemContainer = styled(CardItem)`
  display: flex;
  align-items: start;
  flex-direction: column;
`;
